// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// nodejs v12.18.2
import Vue from 'vue'
import App from './App'
import router from './router'

import Vuex from 'vuex'
Vue.use(Vuex)
import {store} from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import http from './http'

Vue.use(ElementUI);


Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
 
  if(to.name == "Edit"){
   
    http.get("/api/project/islogin").then(res=>{
     
      if(res.data.code!=1){
        next({name:"Login"})
      }
    })
  } 
  
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:store,
  http,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js